import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
import { registerSingleton } from '../../../platform/instantiation/common/extensions.js';
import { CodeLensModel } from './codelens.js';
import { LRUCache } from '../../../base/common/map.js';
import { IStorageService, WillSaveStateReason } from '../../../platform/storage/common/storage.js';
import { Range } from '../../common/core/range.js';
import { runWhenIdle } from '../../../base/common/async.js';
import { once } from '../../../base/common/functional.js';
export var ICodeLensCache = createDecorator('ICodeLensCache');

var CacheItem = function CacheItem(lineCount, data) {
  _classCallCheck(this, CacheItem);

  this.lineCount = lineCount;
  this.data = data;
};

var CodeLensCache = /*#__PURE__*/function () {
  function CodeLensCache(storageService) {
    var _this = this;

    _classCallCheck(this, CodeLensCache);

    this._fakeProvider = new ( /*#__PURE__*/function () {
      function _class() {
        _classCallCheck(this, _class);
      }

      _createClass(_class, [{
        key: "provideCodeLenses",
        value: function provideCodeLenses() {
          throw new Error('not supported');
        }
      }]);

      return _class;
    }())();
    this._cache = new LRUCache(20, 0.75); // remove old data

    var oldkey = 'codelens/cache';
    runWhenIdle(function () {
      return storageService.remove(oldkey, 1
      /* WORKSPACE */
      );
    }); // restore lens data on start

    var key = 'codelens/cache2';
    var raw = storageService.get(key, 1
    /* WORKSPACE */
    , '{}');

    this._deserialize(raw); // store lens data on shutdown


    once(storageService.onWillSaveState)(function (e) {
      if (e.reason === WillSaveStateReason.SHUTDOWN) {
        storageService.store(key, _this._serialize(), 1
        /* WORKSPACE */
        );
      }
    });
  }

  _createClass(CodeLensCache, [{
    key: "put",
    value: function put(model, data) {
      // create a copy of the model that is without command-ids
      // but with comand-labels
      var copyItems = data.lenses.map(function (item) {
        var _a;

        return {
          range: item.symbol.range,
          command: item.symbol.command && {
            id: '',
            title: (_a = item.symbol.command) === null || _a === void 0 ? void 0 : _a.title
          }
        };
      });
      var copyModel = new CodeLensModel();
      copyModel.add({
        lenses: copyItems,
        dispose: function dispose() {}
      }, this._fakeProvider);
      var item = new CacheItem(model.getLineCount(), copyModel);

      this._cache.set(model.uri.toString(), item);
    }
  }, {
    key: "get",
    value: function get(model) {
      var item = this._cache.get(model.uri.toString());

      return item && item.lineCount === model.getLineCount() ? item.data : undefined;
    }
  }, {
    key: "delete",
    value: function _delete(model) {
      this._cache.delete(model.uri.toString());
    } // --- persistence

  }, {
    key: "_serialize",
    value: function _serialize() {
      var data = Object.create(null);

      var _iterator = _createForOfIteratorHelper(this._cache),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          var lines = new Set();

          var _iterator2 = _createForOfIteratorHelper(value.data.lenses),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var d = _step2.value;
              lines.add(d.symbol.range.startLineNumber);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          data[key] = {
            lineCount: value.lineCount,
            lines: _toConsumableArray(lines.values())
          };
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return JSON.stringify(data);
    }
  }, {
    key: "_deserialize",
    value: function _deserialize(raw) {
      try {
        var data = JSON.parse(raw);

        for (var key in data) {
          var element = data[key];
          var lenses = [];

          var _iterator3 = _createForOfIteratorHelper(element.lines),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var line = _step3.value;
              lenses.push({
                range: new Range(line, 1, line, 11)
              });
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          var model = new CodeLensModel();
          model.add({
            lenses: lenses,
            dispose: function dispose() {}
          }, this._fakeProvider);

          this._cache.set(key, new CacheItem(element.lineCount, model));
        }
      } catch (_a) {// ignore...
      }
    }
  }]);

  return CodeLensCache;
}();

CodeLensCache = __decorate([__param(0, IStorageService)], CodeLensCache);
export { CodeLensCache };
registerSingleton(ICodeLensCache, CodeLensCache);